module.exports = __webpack_public_path__ + "img/contract-status-3.9a672bdf.png";